const  citiesList = [
    "Karachi",
    "Lahore",
    "Islamabad",
    "Rawalpindi",
    "Faisalabad",
    "Abottabad",
    "Ahmedpur East",
    "Alipur",
    "Arifwala",
    "Attock",
    "Bahawalnagar",
    "Bahawalpur",
    "Basirpur",
    "Batkhela",
    "Bhalwal",
    "Bhimber",
    "Burewala",
    "Chakwal",
    "Charsadda",
    "Chichawatni",
    "Chiniot",
    "Chishtian",
    "Chitral",
    "Dadu",
    "Dadyal AK",
    "Daharki",
    "Daska",
    "Depalpur",
    "Dera Ghazi Khan",
    "Dera Ismail Khan",
    "Ghotki",
    "Gojra",
    "Gujranwala",
    "Gujrat",
    "Hafizabad ",
    "Haripur",
    "Haroonabad",
    "Hasilpur",
    "Haveli Lakha",
    "Hujra Shah Mukeem",
    "Hyderabad",
    "Jacobabad",
    "Jampur",
    "Jaranwala",
    "Jauharabad",
    "Jhang",
    "Jhelum",
    "Kabirwala",
    "Kamalia",
    "Kamoke",
    "Kandh Kot",
    "Karianwala",
    "Khairpur Mirs",
    "Khanewal",
    "Khanpur",
    "Kharian",
    "Khushab",
    "Kohat",
    "Kot Abdul Malik",
    "Kotla Arab Ali Khan",
    "Kotli AK",
    "Lala Musa",
    "Larkana",
    "Layyah",
    "Liaqatpur",
    "Lodhran",
    "Mandi Bahauddin",
    "Mansehra",
    "Mardan",
    "Mian Channu",
    "Mianwali",
    "Mingora",
    "Mirpur Azad Kashmir",
    "Mirpur Khas",
    "Mirpur Mathelo",
    "Moro",
    "Multan",
    "Muzaffarabad",
    "Muzaffargarh ",
    "Nankana Sahib",
    "Narowal",
    "Naudero",
    "Nawab Shah",
    "Naushahro Feroze",
    "Nowshera",
    "Nowshera Virkan",
    "Okara",
    "Pak Pattan Sharif",
    "Pano Aqil",
    "Pasrur",
    "Peshawar",
    "Qazi Ahmed",
    "Quetta",
    "Rahim Yar Khan",
    "Rajanpur",
    "Renala Khurd",
    "Sadiqabad",
    "Sahiwal",
    "Sambrial",
    "Samundri",
    "Sargodha",
    "Shahdadkot",
    "Shahpur Chakar",
    "Shakargarh",
    "Shehdadpur",
    "Sheikhupura",
    "Shikarpur",
    "Sialkot",
    "Sukkur",
    "Swabi",
    "Swat",
    "Tando Adam",
    "Tando Allah Yar",
    "Tando Muhammad Khan",
    "Taxila",
    "Thatta",
    "Toba Tek singh",
    "Vehari",
    "Wah Cantt",
    "Wazirabad",
    "Zafarwal",
  ];

const noSelectedOption = '<option id="city-empty" value="0" >Select City Name</option>';
let cityNames = "";
for (let i = 0; i < citiesList.length; i++)
  cityNames += `<option value="${citiesList[i]}"> ${citiesList[i]}</option>`;


document.getElementById("city-dropdown").innerHTML =
  noSelectedOption + cityNames;
